import React from "react";
import Guard from "images/Guard2.svg";

const TrustedLogo = () => {
  return (
    <div className="mt-8 text-base flex items-center text-left text-boost-price-green whitespace-normal md:whitespace-nowrap">
      <img src={Guard} alt="" className="inline mr-2" style={{ width:"auto", height: "1.5rem" }}/>
      <span>
        Trusted by <span className="font-bold">4 million+</span>{" "}
        users
      </span>
    </div>
  );
};

export default TrustedLogo;